"use client";

export const PENDING_DRIFT_CHALLENGE_KEY = "thinknado:pending-drift-challenge";
export const PENDING_START_QUERY_PARAM = "pendingStart";

const PENDING_DRIFT_CHALLENGE_TTL_MS = 1000 * 60 * 60 * 6; // 6 hours

interface PendingDriftChallengePayload {
  challenge: string;
  createdAt: number;
}

function getStorage() {
  if (typeof window === "undefined") return null;
  return window.localStorage;
}

export function savePendingDriftChallenge(challenge: string) {
  const trimmed = challenge.trim();
  if (!trimmed) return;

  const storage = getStorage();
  if (!storage) return;

  const payload: PendingDriftChallengePayload = {
    challenge: trimmed,
    createdAt: Date.now(),
  };

  storage.setItem(PENDING_DRIFT_CHALLENGE_KEY, JSON.stringify(payload));
}

export function readPendingDriftChallenge(): string | null {
  const storage = getStorage();
  if (!storage) return null;

  const raw = storage.getItem(PENDING_DRIFT_CHALLENGE_KEY);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw) as PendingDriftChallengePayload;
    const challenge = String(parsed.challenge || "").trim();
    const createdAt = Number(parsed.createdAt || 0);

    if (!challenge) {
      storage.removeItem(PENDING_DRIFT_CHALLENGE_KEY);
      return null;
    }

    if (!Number.isFinite(createdAt) || Date.now() - createdAt > PENDING_DRIFT_CHALLENGE_TTL_MS) {
      storage.removeItem(PENDING_DRIFT_CHALLENGE_KEY);
      return null;
    }

    return challenge;
  } catch {
    storage.removeItem(PENDING_DRIFT_CHALLENGE_KEY);
    return null;
  }
}

export function consumePendingDriftChallenge(): string | null {
  const challenge = readPendingDriftChallenge();
  const storage = getStorage();
  if (storage) {
    storage.removeItem(PENDING_DRIFT_CHALLENGE_KEY);
  }
  return challenge;
}

export function clearPendingDriftChallenge() {
  const storage = getStorage();
  if (!storage) return;
  storage.removeItem(PENDING_DRIFT_CHALLENGE_KEY);
}
